import styled from 'styled-components';

export const MainContent = styled.div`
  overflow-y: auto;
  width: 100%;
  height: 100%;
`;
